export default {
  events: [],
  event: undefined,
};
